<template>
  <div
    class="flex flex-col gap-32 p-16 md:p-24 bg-[#F9F7F5] min-h-[100vh]"
    data-test="other-sellers-drawer-body"
  >
    <!-- First Half: Clickable Fake Offers Section -->
    <OtherSellersOffersSection
      :product-image="drawerData.productImage.value"
      :product-image-alt="drawerData.productImageAlt.value"
      :product-name="drawerData.productName.value"
      :selected-price="drawerData.selectedOffer.value?.price"
      :selected-seller-name="drawerData.selectedOffer.value?.merchant?.company"
      :selected-seller-rating="drawerData.selectedSellerRating.value"
      :selected-tags="drawerData.selectedTags.value"
      @select-offer="handleSelectOffer"
    />

    <!-- Second Half: Survey / Feedback Card -->
    <div ref="feedbackCardContainerRef">
      <Transition
        v-show="isFeedbackFormVisible"
        appear
        enter-from-class="opacity-0"
        enter-to-class="opacity-1"
        enter-active-class="transition-opacity duration-150"
      >
        <OtherSellersFeedbackCard
          :merchant-id="drawerData.selectedOffer.value?.merchant?.merchantId"
          :offer-id="drawerData.selectedOffer.value?.offerId"
          :product-id="drawerData.productId.value"
        />
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, shallowRef } from 'vue'

import { sleep } from '@backmarket/utils/async/sleep'

import { useOtherSellersDrawerData } from '../../composables/useOtherSellersDrawerData/useOtherSellersDrawerData'
import { useOtherSellersTracking } from '../../composables/useOtherSellersTracking/useOtherSellersTracking'
import OtherSellersFeedbackCard from '../OtherSellersFeedbackCard/OtherSellersFeedbackCard.vue'
import OtherSellersOffersSection from '../OtherSellersOffersSection/OtherSellersOffersSection.vue'

const props = defineProps<{
  productId?: string
  grade?: string | number
  specialOfferType?: string
}>()

const feedbackCardContainerRef = ref<HTMLElement | null>(null)
const isFeedbackFormVisible = shallowRef(false)

const drawerData = useOtherSellersDrawerData(props)
const { trackOtherSellersFakeOfferClicked } = useOtherSellersTracking()

onMounted(() => {
  nextTick().then(async () => {
    await sleep(150)
    isFeedbackFormVisible.value = true
  })
})

function handleSelectOffer() {
  nextTick().then(async () => {
    await sleep(150)
    feedbackCardContainerRef.value?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  })

  trackOtherSellersFakeOfferClicked({
    productId: drawerData.productId.value,
    offerId: drawerData.selectedOffer.value?.offerId,
  })
}
</script>
